<div class="page-container">
  <div class="full-height">
    <mat-sidenav-container class="container">
      <mat-sidenav #sidenav (click)="sidenav.close()" align="end" mode="over">
        @if (loggedIn) {
          <button class="sidenav-link dashboard" mat-button routerLink="/">
            <mat-icon>dashboard</mat-icon>
            Dashboard
          </button>
        }
        @if (loggedIn) {
          <ul>
            <li>Users</li>
            <li>Organisations</li>
            <li>Categories</li>
            <li>Batches</li>
          </ul>
        }
        @if (loggedIn) {
          <button (click)="logout()" class="sidenav-link logout" mat-button>
            <mat-icon>exit_to_app</mat-icon>
            Logout
          </button>
        }
      </mat-sidenav>
      <header>
        <mat-toolbar>
          <span routerLink="/" class="title"></span>
          @if (loggedIn) {
            <mat-icon (click)="sidenav.open()" matTooltip="Open menu."
              >menu</mat-icon
            >
          }
        </mat-toolbar>
      </header>

      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-container>
  </div>
</div>
